import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import createCurrencyFormatter from '../utils/formFormatters';
import './styles.scss';

class StakeField extends Component {

    onStakeInputClick = () => {
        const {
            targetId,
            freezeStake,
            isEditingStake,
            setIsEditingStake,
        } = this.props

        if (!isEditingStake && !freezeStake) {
            setIsEditingStake(targetId, true);
        }
    }

    onStakeInputChange = (e) => {
        const {
            targetId,
            setStake,
            onStakeUpdated,
        } = this.props;

        const stakeParts = e.target.value.split('.');

        // Reject cases with more than 1 period e.g. "5.2.1"
        if (stakeParts.length <= 2) {
            // Reject cases of period + more than 2 decimal numbers e.g. "2.001"
            if (stakeParts.length === 2 && stakeParts[1].length > 2) {
                return;
            }

            setStake(targetId, e.target.value);

            // Note: onStakeUpdated is used for validation purposes.
            // Currently multiples have no validation.
            if (typeof onStakeUpdated === 'function') {
                onStakeUpdated(e.target.value, targetId)
            }
        }
    }

    onStakeInputBlur = () => {
        const {
            targetId,
            stakeValue,
            setStake,
            onStakeUpdated,
        } = this.props;

        const value = parseFloat(stakeValue).toFixed(2);
        setStake(targetId, value);

        if (typeof onStakeUpdated === 'function') {
            onStakeUpdated(value, targetId)
        }
    }

    render() {
        const {
            stakeValue,
            currencySign,
            isMobile,
            placeholder,
            freezeStake,
        } = this.props;

        const formattedStakeValue = createCurrencyFormatter(currencySign)(stakeValue);

        return (
            <div className="bs-stakeField">
                {
                    isMobile ? (
                        <span
                            role="button"
                            tabIndex={0}
                            onClick={this.onStakeInputClick}
                            className={classNames(
                                    'bs-input',
                                    'bs-form__input',
                                    'bs-stakeField__input',
                                {
                                    'bs-stakeField__input_placeholder':
                                            !stakeValue,
                                },
                                )}
                        >
                            {
                                    stakeValue
                                        ? formattedStakeValue
                                        : placeholder
                                }
                        </span>
                    ) : (
                        <input
                            name="stake"
                            type="text"
                            onChange={this.onStakeInputChange}
                            onBlur={this.onStakeInputBlur}
                            placeholder={placeholder}
                            maxLength={9}
                            disabled={freezeStake}
                            value={stakeValue ? formattedStakeValue : ''}
                            autoComplete="off"
                            className={
                                classNames(
                                    'bs-input',
                                    'bs-form__input',
                                    'bs-stakeField__input',
                                )
                            }
                        />
                    )
                }
            </div>
        );
    }
}

StakeField.defaultProps = {
    onStakeUpdated: null,
    isMobile: false,
    freezeStake: false,
    stakeValue: '',
    placeholder: 'Stake',
}

StakeField.propTypes = {
    placeholder: PropTypes.string,
    stakeValue: PropTypes.string,
    targetId: PropTypes.string.isRequired,
    currencySign: PropTypes.string.isRequired,
    isMobile: PropTypes.bool,
    freezeStake: PropTypes.bool,
    isEditingStake: PropTypes.bool.isRequired,
    onStakeUpdated: PropTypes.func,
    setIsEditingStake: PropTypes.func.isRequired,
    setStake: PropTypes.func.isRequired,
}

export default StakeField;



// WEBPACK FOOTER //
// /src/js/common/stakeField/StakeField.jsx